require('./src/jquery.tokeninput.js')



//////////////////
// WEBPACK FOOTER
// ./~/jquery-tokeninput/index.js
// module id = 416
// module chunks = 1